<template>
  <div>
    <!-- Filters -->
    <b-row>
      <b-col>
        <b-form-group label="Batch">
          <v-select
            v-model="form.batch"
            :options="batchList"
            :reduce="(option) => option.value"
            label="label"
            placeholder="Select Batch"
          />
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Intake">
          <v-select
            v-model="form.intake"
            :options="intakeList"
            :reduce="(option) => option.value"
            label="label"
            placeholder="Select Intake"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-form-group label="User">
          <v-select
            v-model="selectedUser"
            :options="filteredUsers"
            label="name"
            placeholder="Select User"
            :disabled="!form.batch || !form.intake"
            @input="loadPayments"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Summary -->
    <div
      v-if="selectedUser"
      class="pt-3"
    >
      <div class="paid_months">
        <span class="title">
          Active Status for {{ selectedUser.name }}:
          <span class="font-weight-bold">{{ active_status || 'N/A' }}</span>
        </span>
      </div>

      <div class="paid_months">
        <span class="title">
          Installment Plan:
          <span class="font-weight-bold">{{ formatInstallmentPlan(selectedUser) }}</span>
        </span>
      </div>

      <div class="paid_months">
        <span class="title">
          {{ selectedUser.name }}'s Paid Total:
          <span class="font-weight-bold">{{ getPrice(paid_total) }}</span>
        </span>
      </div>

      <div class="paid_months">
        <span class="title">
          {{ selectedUser.name }}'s Due Total:
          <span class="font-weight-bold">{{ getPrice(due_total) }}</span>
        </span>
      </div>
      <div class="paid_months">
        <span class="title">
          {{ selectedUser.name }}'s Due Date:
          <span class="font-weight-bold">{{ selectedUser.due_date }}</span>
        </span>
      </div>

      <div class="paid_months">
        <span class="title">
          {{ selectedUser.name }}' Installment Due:
          <span class="font-weight-bold">{{ getPrice(inst_due) }}</span>
        </span>
      </div>

      <!-- Payment Table -->
      <div class="pt-3">
        <PaymentTable :payments="payments" />
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import PaymentTable from '@/views/PaymentManagement/Components/PaymentTable'
import paymentApi from '@/Api/Modules/payment'
import usersApi from '@/Api/Modules/auth'
import { BCol, BRow, BFormGroup } from 'bootstrap-vue'

export default {
  components: {
    vSelect,
    PaymentTable,
    BCol,
    BRow,
    BFormGroup,
  },
  data() {
    return {
      form: {
        batch: null,
        intake: null,
      },
      batchList: [
        { label: 'B03', value: 'B03' },
        { label: 'B04', value: 'B04' },
        { label: 'B05', value: 'B05' },
        { label: 'B06', value: 'B06' },
        { label: 'B07', value: 'B07' },
      ],
      intakeList: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
      ],
      users: [], // All users from API
      selectedUser: null, // Selected user after filtering
      payments: [], // Payment history
      paid_total: '', // Total paid amount
      due_total: '', // Total due amount
      active_status: '', // User status
      inst_due: '',
    }
  },
  computed: {

    // Filters users based on selected batch and intake
    filteredUsers() {
      if (!this.form.batch || !this.form.intake) return []
      return this.users.filter(
        u => u.batch === this.form.batch && u.intake === this.form.intake,
      )
    },
  },
  watch: {
    'form.batch': function () {
      this.selectedUser = null
      this.clearPaymentData()
    },
    'form.intake': function () {
      this.selectedUser = null
      this.clearPaymentData()
    },
  },
  async created() {
    await this.loadUsers()
  },
  methods: {
    formatInstallmentPlan(user) {
      if (user.payment_type !== 'Instalment Payment') return 'N/A'
      if (Number(user.installment_plan) === 4) return '4 Months'
      if (Number(user.installment_plan) === 6) return '6 Months'
      return 'N/A'
    },
    getPrice(val) {
      return `Rs. ${parseFloat(val || 0).toFixed(2)}`
    },
    clearPaymentData() {
      this.payments = []
      this.paid_total = ''
      this.due_total = ''
      this.active_status = ''
    },
    async loadUsers() {
      this.$vs.loading({ scale: 0.8 })
      const res = await usersApi.allUsers()
      this.users = res.data.data
      this.$vs.loading.close()
    },
    async loadPayments() {
      if (!this.selectedUser) return

      const payload = {
        user_id: this.selectedUser.id,
      }

      this.$vs.loading({ scale: 0.8 })

      try {
        const res = await paymentApi.allPayments(payload)
        const baseData = res.data.data

        this.payments = baseData.payments.map(payment => ({
          ...payment,
          batch: baseData.batch,
          intake: baseData.intake,
        }))

        this.paid_total = baseData.paid_total
        this.active_status = baseData.active_status
        this.due_total = baseData.due_total
        this.inst_due = baseData.installment_due
      } catch (error) {
        console.error('Error loading payments:', error)
      } finally {
        this.$vs.loading.close()
      }
    },
  },
}
</script>
